import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { urlQuery, userDestroySession, userIs } from "../../../utils/helpers";
import {
  setOrderScreen,
  setOrderStep,
  setPlaceOrderData,
  setNotificationData,
  resetStorage,
} from "../../../redux/actions";
import classNames from "classnames";

import ServiceBullet from "../../../images/order/order-service-bullets.svg";
import ServiceBulletActive from "../../../images/order/order-service-bullets-active.svg";
import { ButtonWithArrow, OrderBackButton } from "./ButtonWithArrow";
import { Button } from "../../../components/refectored/Button";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import moment from "moment-timezone";

import translation from "../../../translations/AsideOrderScreen";
import Api from "../../../utils/api/Api";

// Import the new modern styles
import "./ModernAsideOrderScreen.scss";

const AsideOrderScreen = (props) => {
  const lang = localStorage.getItem("lang");
  const {
    setOrderScreen,
    setNotificationData,
    orderData,
    currentOrderStep,
    setOrderStep,
    selectedPickupDate,
    selectedPickupTime,
    selectedDeliveryDate,
    selectedDeliveryTime,
    placeOrderData,
    userLocation,
    userData,
    checkedLastScreen,
    hasBag,
  } = props;
  const { DC, WF, SS, LS, IO } = orderData;

  async function placedOrder(data) {
    data.user.hasBag = null === hasBag ? false : hasBag;

    try {
      await Api.placeOrder(data);

      props.history.push(urlQuery({ page: "order-placed" }));
      props.resetStorage();

      await userDestroySession();

      setOrderScreen(4);
    } catch (e) {
      const message = e.response.data.title;
      const data = { status: true, message };
      setNotificationData(data);

      setTimeout(() => {
        const data = { status: false, message: "" };
        setNotificationData(data);
      }, 5000);
    }
  }

  const setPlaceOrder = async () => {
    const encodeDates = (date, time) =>
      moment.tz(`${date}T${time}:00`, "Europe/Amsterdam").format();

    let selectedServices = [];
    let placeData = placeOrderData;
    Object.keys(orderData).filter((key) => {
      return orderData[key] && selectedServices.push(key);
    });

    const userPayload = { ...userData };
    const { contactEmail, contactPhone, contactName } = userPayload;

    const data = {
      user: userPayload,
      order: {
        ...placeData,
        deliveryTime: encodeDates(
          selectedDeliveryDate.date,
          selectedDeliveryTime
        ),
        pickupTime: encodeDates(selectedPickupDate.date, selectedPickupTime),
        pickupLocation: { ...userLocation },
        deliveryLocation: { ...userLocation },
        cleaningServices: selectedServices,
        data: {
          contact: {
            name: contactName,
            email: contactEmail,
            phone: contactPhone,
          },
        },
        b2bType: "re-use",
      },
    };
    await placedOrder(data);
  };

  const getNextButtonState = () => {
    const { phone, name, fullName } = userData;

    switch (currentOrderStep) {
      case 1:
        return !!DC || !!WF || !!SS || !!LS || !!IO;
      case 2:
        return (
          !!!selectedPickupDate.default &&
          !!!selectedDeliveryDate.default &&
          selectedDeliveryTime !== "00:00"
        );
      case 3: {
        return (phone && name && checkedLastScreen) || fullName;
      }
      default:
        return false;
    }
  };

  const handleChangeStep = (direction) => {
    const { contactName, contactEmail, contactPhone } = userData;
    const backDirection = direction === "back";

    switch (currentOrderStep) {
      case 1:
        return backDirection
          ? setOrderScreen(2)
          : (DC || WF || SS || LS || IO) && setOrderStep(2);
      case 2:
        return backDirection
          ? setOrderStep(1)
          : !!!selectedPickupDate.default &&
              !!!selectedDeliveryDate.default &&
              selectedDeliveryTime !== "00:00" &&
              setOrderStep(3);
      case 3:
        return backDirection
          ? setOrderStep(2)
          : contactName &&
              contactEmail &&
              contactPhone &&
              checkedLastScreen &&
              setPlaceOrder();
      default:
        break;
    }
  };

  const buttonTextSteps = {
    1: translation.next_time[lang],
    2: translation.next_overview[lang],
    3: translation.confirmOrder[lang],
  };
  const buttonText = buttonTextSteps[currentOrderStep];

  const WrapperClassName = classNames({
    "modern-step-wrapper": true,
  });

  const ProgressClassName = classNames({
    "modern-step-progress": true,
    "step-2": currentOrderStep === 2,
    "step-3": currentOrderStep === 3,
  });

  return (
    <div className="modern-aside-order-screen">
      {/* Mobile step indicators */}
      <div className="modern-mobile-steps">
        <div
          className={`mobile-step-indicator ${
            currentOrderStep >= 1 ? "active" : ""
          } ${currentOrderStep > 1 ? "completed" : ""}`}
        >
          {currentOrderStep > 1 ? null : <span>1</span>}
        </div>
        <div
          className={`mobile-step-line ${
            currentOrderStep > 1 ? "completed" : ""
          }`}
        ></div>
        <div
          className={`mobile-step-indicator ${
            currentOrderStep >= 2 ? "active" : ""
          } ${currentOrderStep > 2 ? "completed" : ""}`}
        >
          {currentOrderStep > 2 ? null : <span>2</span>}
        </div>
        <div
          className={`mobile-step-line ${
            currentOrderStep > 2 ? "completed" : ""
          }`}
        ></div>
        <div
          className={`mobile-step-indicator ${
            currentOrderStep >= 3 ? "active" : ""
          }`}
        >
          <span>3</span>
        </div>
      </div>

      <div className="modern-order-layout">
        <div className="modern-left-order-block">{props.children}</div>
        <div className="modern-right-order-block">
          <div className={WrapperClassName}>
            <div className={ProgressClassName}></div>
            <ModernCurrentServiceSelect
              active={currentOrderStep === 1}
              title="Service"
              descr={translation.selectServiceDescr[lang]}
            />
            <ModernCurrentServiceSelect
              active={currentOrderStep === 2}
              title={translation.time[lang]}
              descr={translation.timeDescr[lang]}
            />
            <ModernCurrentServiceSelect
              active={currentOrderStep === 3}
              title={translation.overview[lang]}
              descr={translation.overviewDesc[lang]}
            />
          </div>
          <div className="modern-step-buttons">
            {1 !== currentOrderStep && (
              <Button
                id={
                  "step-" +
                  (currentOrderStep + 2) +
                  "-back-to-step-" +
                  (currentOrderStep + 1)
                }
                className="modern-next-button"
                color="green"
                iconBefore={
                  <ArrowBack style={{ color: "#ffffff", fontSize: "18px" }} />
                }
                onClick={() => handleChangeStep("back")}
              >
                {translation.back[lang]}
              </Button>
            )}

            <Button
              id={
                3 === currentOrderStep
                  ? "step-5-purchase-button"
                  : "step-" +
                    (currentOrderStep + 2) +
                    "-next-to-step-" +
                    (currentOrderStep + 3)
              }
              iconAfter={
                <ArrowForward style={{ color: "#ffffff", fontSize: "18px" }} />
              }
              className="modern-next-button"
              color="green"
              onClick={() => handleChangeStep()}
              isDisabled={!getNextButtonState()}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ModernCurrentServiceSelect = (props) => {
  const { active, title, descr } = props;
  return (
    <div className={`modern-service-item ${active ? "active" : ""}`}>
      <div className="modern-bullet-icon">
        <img src={active ? ServiceBulletActive : ServiceBullet} alt="" />
      </div>
      <div className="modern-bullet-text">
        <span className="step-title">{title}</span>
        <span className="step-description">{descr}</span>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  currentOrderScreen,
  orderData,
  currentOrderStep,
  selectedPickupDate,
  selectedDeliveryDate,
  selectedPickupTime,
  selectedDeliveryTime,
  placeOrderData,
  userLocation,
  userData,
  apiToken,
  checkedLastScreen,
  hasBag,
}) => ({
  currentOrderScreen,
  orderData,
  currentOrderStep,
  selectedPickupDate,
  selectedDeliveryDate,
  selectedPickupTime,
  selectedDeliveryTime,
  placeOrderData,
  userLocation,
  userData,
  token: apiToken,
  checkedLastScreen,
  hasBag,
});
const mapDispatchToProps = (dispatch) => {
  return {
    setOrderScreen: (data) => dispatch(setOrderScreen(data)),
    setPlaceOrderData: (data) => dispatch(setPlaceOrderData(data)),
    setNotificationData: (data) => dispatch(setNotificationData(data)),
    setOrderStep: (data) => dispatch(setOrderStep(data)),
    resetStorage: () => dispatch(resetStorage()),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AsideOrderScreen);
